<template>
  <div class="lucky">
    <div class="zz-page luck-page">
      <div class="page-content-new flex-box-div">
        <otherHeaderTop
          headerTitle="幸运饰品"
          :showBack="true"
          @back="back"
          :showBalanceOne="false"
        ></otherHeaderTop>
        <div class="lucky-content-wrap">
          <div class="content-top">
            <div @click="showRule = true">
              <img
                src="../../assets/image3/blindBox/question.png"
                alt=""
                class="rule-icon"
              />
            </div>

            <div class="lucky-clock-box">
              <div class="lucky-clock" data-arr="" open-size="1" animation="0">
                <!-- <svg
                  width="190px"
                  height="190px"
                  divBox="0 0 400 400"
                  class="svg-progress"
                >
                  <defs>
                    <linearGradient
                      id="lgColor"
                      x1="100%"
                      y1="100%"
                      x2="0%"
                      y2="0%"
                    >
                      <stop offset="0%" stop-color="#0FFBFF"></stop>
                      <stop offset="100%" stop-color="#0FFBFF"></stop>
                    </linearGradient>
                    <linearGradient
                      id="lgColor1"
                      x1="100%"
                      y1="100%"
                      x2="0%"
                      y2="0%"
                    >
                      <stop offset="0%" stop-color="#fda6ff"></stop>
                      <stop offset="100%" stop-color="#fda6ff"></stop>
                    </linearGradient>
                  </defs>
                  <circle
                    r="180"
                    cx="200"
                    cy="200"
                    stroke-width="20"
                    stroke="#21252b"
                    fill="none"
                    stroke-dasharray="5"
                    transform="translate(0,400) rotate(-90)"
                    class=""
                  ></circle>
                  <circle
                    r="180"
                    cx="200"
                    cy="200"
                    stroke-width="20"
                    stroke="#474F5C"
                    fill="none"
                    stroke-dasharray="5"
                    transform="translate(0,400) rotate(-90)"
                    class=""
                  ></circle>
                  <circle
                    r="180"
                    cx="200"
                    cy="200"
                    stroke-width="20"
                    fill="none"
                    stroke="url(#lgColor1)"
                    :stroke-dasharray="percentDynamic"
                    transform="rotate(-90, 200, 200)"
                    class="dashAnima1"
                  ></circle>
                  <circle
                    r="180"
                    cx="200"
                    cy="200"
                    stroke-width="20"
                    fill="none"
                    stroke="url(#lgColor)"
                    :stroke-dasharray="percentDynamic"
                    transform="rotate(-90, 200, 200)"
                    class="dashAnima1"
                  ></circle>
                </svg> -->
                <img
                  class="top-progress-back"
                  src="../../assets/image3/blindBox/progress-ring.png"
                  alt=""
                />

                <el-progress
                  class="top-progress"
                  type="circle"
                  stroke-linecap="butt"
                  color="#11FAFF"
                  define-back-color="#000A4E"
                  :percentage="percent"
                  :stroke-width="11"
                ></el-progress>
                <div
                  class="pointer-box run-bg"
                  :style="{
                    rotate: `${prizeRotate}deg`,
                    transitionDuration: prizeRotate == 0 ? 'unset' : '6s',
                  }"
                >
                  <div class="pointer-inner">
                    <div class="pointer-light" v-if="dynamic"></div>
                  </div>
                </div>
                <div class="percentage-box">
                  <div class="progress">{{ percent }}%</div>
                  <!-- <div class="unit">%</div> -->
                </div>
              </div>
            </div>
            <div class="left-prod">
              <template v-if="targetOrnaments">
                <div class="name text-ellipsis">
                  {{ targetOrnaments.shortName }}
                </div>
                <div class="prod-img">
                  <img
                    alt=""
                    :src="$getFullPath(targetOrnaments.imageUrl)"
                    mode="aspectFit"
                  />
                  <!-- <div class="wear">
                    {{ targetOrnaments.exteriorName }}
                  </div> -->
                </div>
              </template>
              <template v-else>
                <div class="name text-ellipsis"></div>
                <div class="prod-img">
                  <div class="wear">请选择饰品</div>
                </div>
              </template>
            </div>
            <div class="right-box">
              <template v-if="resultOrnaments != null && showResult">
                <template v-if="resultOrnaments != '失败啦，啥都没得到~'">
                  <!-- <div class="name text-ellipsis">
                    {{ resultOrnaments.ornamentName }}
                  </div> -->
                  <div class="prod-img">
                    <img
                      alt=""
                      :src="$getFullPath(resultOrnaments.ornamentImgUrl)"
                      mode="aspectFit"
                    />
                    <div class="wear text-ellipsis">
                      {{ resultOrnaments.ornamentName }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <!-- <div class="name text-ellipsis"></div> -->
                  <div class="prod-img">
                    <div class="wear text-ellipsis">{{ resultOrnaments }}</div>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="name text-ellipsis"></div>
                <div class="prod-img">
                  <img
                    class="prod-img-question"
                    src="../../assets/image3/blindBox/sjwb-question.png"
                    mode="aspectFit"
                    alt=""
                  />
                  <div class="wear">随机物品</div>
                </div>
              </template>
            </div>
            <!-- <el-progress
                  type="line"
                  stroke-linecap="butt"
                  color="#11FAFF"
                  define-back-color="#474F5C"
                  :percentage="percent"
                  :show-text="false"
                ></el-progress> -->
            <div class="progress-box-wrap">
              <div @click="minusP" class="progress-btn reduce-btn">
                <img
                  src="../../assets/image3/blindBox/progress-minus.png"
                  alt=""
                  class="reduce-btn-img"
                />
              </div>
              <div class="progress">
                <el-slider
                  class="bottom-slider"
                  v-model="percent"
                  :show-tooltip="false"
                  :min="5"
                  :max="75"
                  @input="handlechange"
                >
                </el-slider>
                <!-- <u-slider
                  class="van-slider"
                  inactiveColor="transparent"
                  v-model="percent"
                  min="0"
                  :max="75 - parseFloat(this.lucky_base_rate)"
                ></u-slider> -->
              </div>
              <div @click="plusP" class="progress-btn add-btn">
                <img
                  src="../../assets/image3/blindBox/progress-add.png"
                  alt=""
                  class="add-btn-img"
                />
              </div>
            </div>
            <div class="tab-box-wrap">
              <div
                @click="changeTab(0)"
                :class="[curTab == 0 ? 'sel' : '']"
                class="btn-item"
              >
                <span>选择道具</span>
              </div>
              <!-- <div class="award-show" style="opacity: 0">
                <div class="color-blue"></div>
                <span>已累计 %</span>
              </div> -->
              <div
                @click="changeTab(1)"
                :class="[curTab == 1 ? 'sel' : '']"
                class="btn-item"
              >
                <span>掉落记录</span>
              </div>
            </div>
          </div>
          <div class="prod-select-box" :class="[curTab == 0 ? 'show' : '']">
            <!-- <div class="page-content-bg">
              <div class="bg-layer1" style="margin-top: 0px"></div>
              <div class="bg-layer2" style="margin-top: 0px"></div>
            </div> -->
            <div class="prod-select-outer" v-if="curTab == 0">
              <div class="scroll-select-wrap">
                <div
                  class="refresh-content van-pull-refresh"
                  style="height: 100%"
                >
                  <div
                    class="van-pull-refresh__track"
                    style="transition-duration: 0ms; height: auto"
                  >
                    <div class="scroll-select-inner">
                      <div
                        @click="selectGoods(item)"
                        v-for="(item, index) in skinsList"
                        :key="index"
                        :class="[item.selected ? 'sel' : '']"
                        class="prod-item"
                      >
                        <!-- <img
                          v-if="item.selected"
                          class="select"
                          src="../../assets/image3/home/selectShop.png"
                          alt=""
                        /> -->
                        <div class="award text-ellipsis">
                          {{ item.shortName }}
                        </div>
                        <div class="name text-ellipsis">
                          {{ item.exteriorName }}
                        </div>
                        <img class="shpo-img" :src="item.imageUrl" alt="" />
                        <div class="price">
                          <img src="@/assets/home/jinbi.png" alt="" />
                          <span>{{ item.usePrice }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="history-order-record"
              v-else
              @scroll="scrollEventRecordFn"
            >
              <div
                class="order-item"
                :class="[item.isVictory == true ? 'sel' : '']"
                v-for="(item, index) in recordList"
                :key="index"
              >
                <div class="user-info">
                  <div class="avatar">
                    <img
                      :src="`${$getFullPath(item.userAvatar)}`"
                      alt=""
                      mode="aspectFit"
                    />
                    <!-- <img :src="item.userAvatar
                      ? item.userAvatar
                      : '../../assets/images/default-header.png'
                      " alt="" mode="aspectFit" /> -->
                    <div class="mask"></div>
                  </div>
                  <div class="text-info">
                    <div class="nick text-ellipsis">
                      {{ item.nickName }}
                    </div>
                    <div class="time">{{ item.openTime }}</div>
                  </div>
                </div>
                <div class="award">{{ item.probability }}%</div>
                <div class="prod-img">
                  <template v-if="item.ornamentList != ''">
                    <img
                      mode="aspectFit"
                      :src="$getFullPath(item.ornamentList.ornamentImgUrl)"
                      alt=""
                    />
                  </template>
                </div>
                <div class="price">
                  <div class="price-1">
                    {{
                      item.amountConsumed &&
                      Number(item.amountConsumed).toFixed(2)
                    }}
                  </div>
                  <div class="price-2">
                    {{ item.targetOrnamentPrice }}
                  </div>
                </div>
              </div>
              <!-- <div class="history-order-scroll-box">
                <div class="scroll-box-inner" style="height: 100%">
                  <div
                    class="refresh-content van-pull-refresh"
                    style="height: 100%"
                  >
                    <div
                      class="van-pull-refresh__track"
                      style="transition-duration: 0ms; height: auto"
                    >
                     
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="btm-opt-box" style="z-index: 10">
        <!-- <div class="top"></div> -->
        <div class="opt-box">
          <div class="btn flex-center" @click="handlederamupgrade">
            <div class="price">{{ openPriceComputed }}开箱</div>
            <!-- <img src="../../assets/images/open-box.png" class="text-img" /> -->
          </div>
          <!-- <div class="btm-layer-1"></div>
          <div class="btm-layer-2"></div> -->
        </div>
        <div class="open-record" @click="showRecordsLuckyTen = true">
          <div class="icon"></div>
        </div>
      </div>
      <div class="set-sound-dialog">
        <div class="common-small-dialog-wrap"></div>
      </div>
      <div class="common-small-dialog-wrap"></div>
      <div></div>
      <div class="confirm-dialog">
        <div></div>
      </div>
    </div>
    <!-- 规则 -->
    <modalRule
      :showModal="showRule"
      @close="showRule = false"
      :rule="rule"
    ></modalRule>
    <!-- 十佳掉落 -->
    <modalRecordsLuckyTen
      :showModal="showRecordsLuckyTen"
      @close="showRecordsLuckyTen = false"
    ></modalRecordsLuckyTen>
    <modalBoxResult
      :showModal="showBoxResult"
      :num="isActive"
      :skinsInfo="skinsInfo"
      @close="showBoxResult = false"
      :boxType="'luckyBox'"
    ></modalBoxResult>
  </div>
</template>

<script>
import modalRecordsLuckyTen from "@/components/common/modalRecordsLuckyTen.vue";
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import modalRule from "@/components/common/modalRule.vue";
import modalBoxResult from "@/components/common/modalBoxResult.vue";
import {
  deramlist,
  deramrecord,
  deramupgrade,
  shopcondition,
  getUserInfo,
} from "@/api/index";
export default {
  components: {
    otherHeaderTop,
    modalRule,
    modalRecordsLuckyTen,
    modalBoxResult,
  },
  data() {
    return {
      success: true,
      onselectweapon: false,
      isqulity: false,
      weaponetype: "类别",
      successRateTow: 3600,
      onOpen: false,
      isResult: false,
      targetOrnaments: null,
      resultOrnaments: null,
      onselect: false,
      percent: Number(25),
      skinsList: [],
      recordList: [],
      qualityList: [],
      queryParams: {
        itemName: "",
        priceMax: null,
        priceMin: null,
      },
      recordParams: {
        size: 10,
        page: 1,
      },
      isOver: "加载中",
      timer: null,
      showRule: false,
      rule: [
        "1、选择您想要的目标饰品。",
        "2、随意选取成功百分比以及对应的ROLL点区间，最低幸运饰品概率为5%，最高75%。",
        "3、幸运饰品金额会根据饰品价值和所选区间相应变化。",
        "4、幸运饰品成功，您将获得目标饰品；幸运饰品失败，您将获得随机安慰奖（无论是否成功，幸运饰品完毕后指针会默认恢复到最高幸运饰品概率处）。",
      ],
      luckyMoney: "0.00",
      // 开奖结束
      showResult: false,
      showRecordsLuckyTen: false,
      // 新的
      ruleContent: "",
      page: 1,
      limit: 10,
      // isOver: false,
      curUnboxPrice: "0.00",
      curTab: 0,
      user: {},
      lucky_base_rate: 0,
      selectGoodsInfo: {},
      prizeRotate: 0,
      dynamic: false,
      randomPrize: null,
      openBoxTimeout: null,
      showResultTimeout: null,
      drops: {
        page: 1,
        limit: 15,
        isOver: false,
        lists: [],
      },
      // 开箱结果盒子
      showBoxResult: false,
      isActive: 1,
      skinsInfo: [],
    };
  },

  mounted() {
    // 获取饰品列表
    this.getDreamList();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  activated() {
    this.$soundStop("indexBgm");
    this.$soundPlay("boxBgm", true);
  },
  methods: {
    unbox() {},
    hide() {},
    unload() {},
    destroy() {},
    doPay() {},
    getMine() {},
    openBox() {},
    getRotate(isPrize = true) {
      let percent = parseFloat(this.percent);
      let prizeArea = Math.ceil((percent * 360) / 100);
      let prizeNoArea = 360 - prizeArea;
      let circle = Math.ceil(Math.random() * 15 + 5);
      let floatRorate = Math.ceil(Math.random() * prizeArea);
      if (!isPrize) {
        floatRorate = Math.floor(Math.random() * prizeNoArea) + prizeArea;
      }
      let deg = circle * 360 + floatRorate;
      return deg;
    },
    calcCirclePercent() {},
    init() {},
    luckyRuleChange() {},
    luckyRecordsChange() {},
    minusP() {
      this.percent -= 1;
    },
    plusP() {
      this.percent += 1;
    },
    openRecords() {},
    selectGoods(item) {
      this.$soundPlay("boxSelect");
      if (this.dynamic) {
        this.$message({
          duration: 1000,
          message: "开奖中",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      this.skinsList.forEach((item) => {
        item.selected = false;
      });
      item.selected = true;
      this.targetOrnaments = item;
      this.luckyMoney = (
        (this.targetOrnaments.usePrice * this.percent) /
        100
      ).toFixed(2);
      this.$forceUpdate();
    },
    changeTab(item) {
      this.curTab = item;
      if (item == 1) {
        this.recordList = [];
        this.getDreamRecord();
      }
    },
    calcUnboxPrice() {},
    getInfo() {},
    refreshDrops() {},
    getGoods() {},
    getDrops() {},

    // 旧的
    back() {
      this.$router.go(-1);
      this.$soundStop("boxBgm");
    },
    playDreamAudio() {
      this.pkAudio.play();
    },
    playAudio() {
      this.$store.commit("playAudio");
    },
    scrollEventFn(e) {
      // console.log(e);
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        // console.log(11);

        if (this.isOver == "加载中") {
          this.recordParams.page++;
          setTimeout(() => {
            this.getDreamRecord();
          }, 5);
        }
      }
    },
    handleilltate() {
      // const data = {};
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        this.$bus.$emit("nr_illustrate", "dream");
      }, 100);
    },
    handleQuality(item) {
      // console.log("12345", item);
      let res = Number(Object.values(item)[0]);
      // console.log(Object.keys(item));
      this.weaponetype = Object.keys(item)[0];
      if (item == 0) {
        this.weaponetype = "类别";

        this.queryParams = {};
        this.handleserch();
      } else {
        this.queryParams.type = res;
        this.handleserch();
      }
      this.isqulity = false;
    },
    handleOnSelectType() {
      this.isqulity = true;
      shopcondition(0).then((res) => {
        this.qualityList = res.data.data;
      });
    },
    handleCloseSelect() {
      this.weaponetype = "类别";
      const element = this.$refs.selectbox; // 获取元素对象
      element.className += " animate__slideOutDown";
      setTimeout(() => {
        this.onselect = false;
        this.$router.back();
      }, 500);
    },
    handleClose() {
      // animate__fadeOutDown
      const element = this.$refs.myElement; // 获取元素对象
      element.className += " animate__fadeOutDown";
      // element.classList.add("animate__fadeOutDown");
      setTimeout(() => {
        this.isResult = false;
      }, 500);
    },
    handleSelect(res) {
      this.handleCloseSelect();
      this.targetOrnaments = res;
      this.recordParams.ornamentId = res.ornamentId;
      this.getDreamRecord();
    },
    handletype() {
      this.recordParams.page = 1;
      this.recordList = [];
      this.getDreamRecord();
    },
    handleserch() {
      // console.log(1);
      this.onselectweapon = true;
      deramlist(this.queryParams).then((res) => {
        this.skinsList = res.data.data;
        setTimeout(() => {
          this.onselectweapon = false;
        }, 350);
      });
    },

    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 0.7) + min + 0.2);
    },
    handlederamupgrade() {
      if (
        this.$store.state.USER_INFO.accountAmount +
          this.$store.state.USER_INFO.accountCredits <
        this.luckyMoney
      ) {
        this.$message({
          duration: 1000,
          message: "余额不足，请充值",
          type: "warning",
          customClass: "log_warning",
        });
        return false;
      } else if (this.$store.state.USER_INFO.isRealCheck == "0") {
        this.$message({
          duration: 1000,
          message: "请先进行实名认证",
          type: "warning",
          customClass: "log_warning",
        });
        return false;
      }
      this.showResult = false;
      let obj = {
        upgradeOrnamentId: this.targetOrnaments.id,
        price: this.luckyMoney,
        probability: this.percent,
      };
      // console.log("obj", obj);
      deramupgrade(obj).then((res) => {
        // if (res.data.code == 500) {
        //   this.$message({
        //     duration: 1000,
        //     message: res.data.msg,
        //     type: "warning",
        //     customClass: "log_warning",
        //   });
        //   return false;
        // }
        // this.onOpen = true;
        // 重置选择角度
        this.prizeRotate = 0;
        clearInterval(this.timer);
        getUserInfo().then((res) => {
          this.user = res.data.data;
          this.$store.commit("USER_INFO", res.data.data);
        });
        const result = res.data.data;
        if (result.gainOrnamentList) {
          this.resultOrnaments = JSON.parse(result.gainOrnamentList)[0];
        } else {
          this.resultOrnaments = "失败啦，啥都没得到~";
        }
        this.openBoxTimeout = setTimeout(() => {
          this.dynamic = true;
          this.$soundPlay("luckyAnim1");
          const isVictory = result.isVictory;
          let deg = this.getRotate(isVictory);
          this.prizeRotate = deg;

          this.showResultTimeout = setTimeout(() => {
            this.$soundPlay("boxOpen");
            if (isVictory && this.resultOrnaments) {
              this.$message({
                duration: 1000,
                message: "恭喜获得珍惜饰品",
                type: "success",
                customClass: "log_success",
              });
            } else if (this.resultOrnaments != "失败啦，啥都没得到~") {
              this.$message({
                duration: 1000,
                message: "恭喜获得饰品",
                type: "success",
                customClass: "log_success",
              });
            } else {
              this.$message({
                duration: 1000,
                message: "很遗憾，未中奖",
                type: "warning",
                customClass: "log_warning",
              });
            }

            this.dynamic = false;
            this.showResultTimeout = null;
            // 显示开奖结果
            this.showResult = true;
            this.skinsInfo = this.resultOrnaments;
            this.skinsInfo.boxRecordIds = result.boxRecordIds;
            this.showBoxResult = true;
          }, 6000);
          this.openBoxTimeout = null;
        }, 1000);
      });
    },
    // handlederamupgrade() {
    //   if (
    //     this.$store.state.USER_INFO.accountAmount +
    //       this.$store.state.USER_INFO.accountCredits <
    //     this.luckyMoney
    //   ) {
    //     this.$message({ duration: 1000,
    //       message: "余额不足，请充值",
    //       type: "warning",
    //       customClass: "log_warning",
    //     });
    //     return false;
    //   } else if (this.$store.state.USER_INFO.isRealCheck == "0") {
    //     this.$message({ duration: 1000,
    //       message: "请先进行实名认证",
    //       type: "warning",
    //       customClass: "log_warning",
    //     });
    //     return false;
    //   }
    //   let obj = {
    //     upgradeOrnamentId: this.targetOrnaments.id,
    //     price: this.luckyMoney,
    //     probability: this.percent,
    //   };
    //   // console.log("obj", obj);
    //   deramupgrade(obj).then((res) => {
    //     if (res.data.code == 500) {
    //       this.$message({ duration: 1000,
    //         message: res.data.msg,
    //         type: "warning",
    //         customClass: "log_warning",
    //       });
    //       return false;
    //     }
    //     this.onOpen = true;
    //     clearInterval(this.timer);
    //     getUserInfo().then((res) => {
    //       this.user = res.data.data;
    //       this.$store.commit("USER_INFO", res.data.data);
    //     });
    //     if (res.data.data.gainOrnamentList) {
    //       this.playDreamAudio();
    //       this.resultOrnaments = JSON.parse(res.data.data.gainOrnamentList)[0];
    //       if (
    //         this.targetOrnaments.usePrice == this.resultOrnaments.ornamentPrice
    //       ) {
    //         // console.log(1);
    //         this.successRateTow =
    //           360 * 15 +
    //           360 * (this.percent / 100) -
    //           Math.floor(Math.random() * (360 * (this.percent / 100)));
    //       } else {
    //         this.successRateTow =
    //           360 * 15 +
    //           360 * (this.percent / 100) +
    //           this.getRandomNumber(360 * (this.percent / 100) + 1, 360) -
    //           360 * (this.percent / 100);
    //       }
    //       setTimeout(() => {
    //         this.onOpen = false;
    //         this.isResult = true;
    //         this.success = true;
    //         this.recordParams.page = 1;
    //         this.recordParams.size = 10;
    //         this.getDreamRecord();
    //         this.timer = setInterval(() => {
    //           if (this.targetOrnaments) {
    //             this.getDreamRecord();
    //           }
    //         }, 5000);
    //       }, 3500);
    //     } else {
    //       this.playDreamAudio();
    //       this.resultOrnaments = "失败啦，啥都没得到~";
    //       this.successRateTow =
    //         360 * 15 +
    //         360 * (this.percent / 100) +
    //         this.getRandomNumber(360 * (this.percent / 100) + 1, 360) -
    //         360 * (this.percent / 100);
    //       setTimeout(() => {
    //         this.onOpen = false;
    //         this.isResult = true;
    //         this.success = false;
    //         this.recordParams.page = 1;
    //         this.recordParams.size = 10;
    //         this.getDreamRecord();
    //         this.timer = setInterval(() => {
    //           if (this.targetOrnaments) {
    //             this.getDreamRecord();
    //           }
    //         }, 5000);
    //       }, 3500);
    //     }
    //   });
    // },

    getDreamRecord() {
      // if (this.targetOrnaments) {
      deramrecord(this.recordParams).then((res) => {
        let records = [];
        if (res.data.code == 200) {
          records = res.data.data.records;

          records.forEach((item) => {
            if (item.gainOrnamentList != "") {
              item.ornamentList = JSON.parse(item.gainOrnamentList)[0];
            } else {
              item.ornamentList = "";
            }
            // item.ornamentList = JSON.parse(item.gainOrnamentList)[0];
            // console.log(item.gainOrnamentList,'测试数据')
          });
          this.recordList.push(...records);
          console.log("recordList", this.recordList);
        }
        if (records.length < this.recordParams.size) {
          this.isOver = "暂无更多";
        }
      });
      // } else {
      //   this.$message({ duration: 1000,
      //     message: "请先选择饰品",
      //     type: "warning",
      //     customClass: "log_warning",
      //   });
      // }
    },
    scrollEventRecordFn(event) {
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        console.log(this.isOver, "23232");
        if (this.isOver == "加载中") {
          this.recordParams.page++;
          setTimeout(() => {
            this.getDreamRecord();
          }, 5);
        } else {
          this.$message({
            duration: 1000,
            message: "暂无更多数据",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },

    getDreamList() {
      // this.onOpen = true;

      // this.successRateTow = 360 * 15;
      // setTimeout(() => {
      //   this.successRateTow;
      //   this.onOpen = false;
      // }, 5000);
      this.onselect = true;
      deramlist().then((res) => {
        this.skinsList = res.data.data;
        // console.log("skinsList", this.skinsList);
      });
    },
    handlechange() {
      let aa = document.getElementsByClassName("el-slider__button")[0];
      aa.innerText = this.percent;
    },
    handleodds(res) {
      this.percent = Number(res);
    },
  },
  computed: {
    // 计算属性
    openPriceComputed() {
      if (this.targetOrnaments) {
        return (this.luckyMoney = (
          (this.targetOrnaments.usePrice * this.percent) /
          100
        )
          .toFixed(2)
          .toString());
      } else {
        return "0.00";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的
.lucky {
  --head-height: 14 * 4.2px;
  margin-top: 4rem;
}

.luck-page .page-content-new {
  // padding-bottom: 32.27 * 4.2px;
  background: url("../../assets/images/top_bkg.png") no-repeat 0 0;
  background-size: 100 * 4.2px 88.4 * 4.2px;
}

.luck-page .lucky-content-wrap {
  width: 100 * 4.2px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.luck-page .lucky-content-wrap .lucky-clock-box {
  position: absolute;
  top: -2.67 * 4.2px;
  left: 27.33 * 4.2px;
  width: 45.33 * 4.2px;
  height: 45.33 * 4.2px;
}

.luck-page .lucky-content-wrap .lucky-clock-box .pointer-bg {
  position: absolute;
  left: -27.33 * 4.2px;
  top: -1px;
  width: 100 * 4.2px;
  height: 65.33 * 4.2px;
  z-index: 1;
}

.luck-page .lucky-content-wrap .lucky-clock-box .box-bg {
  position: absolute;
  left: -27.33 * 4.2px;
  top: -6 * 4.2px;
  width: 100 * 4.2px;
  height: 66.13 * 4.2px;
  opacity: 0.6;
}

.luck-page .lucky-content-wrap .lucky-clock-box .anim {
  -webkit-animation: luckyLineAlphaKf01 0.5s linear 1;
  animation: luckyLineAlphaKf01 0.5s linear 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes luckyLineAlphaKf01 {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes luckyLineAlphaKf01 {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.luck-page .lucky-content-wrap .content-top {
  width: 100 * 4.2px;
  height: 60.67 * 4.2px;
  position: relative;
  margin-top: 1.33 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .rule-icon {
  position: absolute;
  top: 3.07 * 4.2px;
  right: 2.67 * 4.2px;
  width: 4.53 * 4.2px;
  height: 4.53 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .left-prod {
  width: 25.47 * 4.2px;
  height: 23.33 * 4.2px;
  position: absolute;
  z-index: 3;
  left: 2.93 * 4.2px;
  top: 8.27 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .left-prod .name {
  width: 14 * 4.9px;
  height: 6.53 * 4.2px;
  line-height: 6.53 * 4.2px;
  font-size: 2.7 * 4.2px;
  color: #bbcbff;
  text-indent: 1.73 * 4.2px;
  z-index: 2;
  position: absolute;
  top: -0.95 * 4.2px;
  left: 4.29 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .left-prod .prod-img {
  width: 24.05 * 4.2px;
  height: 22.62 * 4.2px;
  background: url("../../assets/image3/blindBox/sjwbBack.png") no-repeat 0 0;
  background-size: 24.05 * 4.2px 22.62 * 4.2px;
  position: relative;
}

.luck-page .lucky-content-wrap .content-top .left-prod .prod-img img,
.luck-page .lucky-content-wrap .content-top .right-box .prod-img img {
  width: 20.13 * 4.2px;
  height: 15.07 * 4.2px;
  margin: 0.93 * 4.2px 1.33 * 4.2px 0.8 * 4.2px 1.33 * 4.2px;
  position: absolute;
  left: 0.95 * 4.2px;
  bottom: 0.48 * 4.2px;
}

.luck-page
  .lucky-content-wrap
  .content-top
  .right-box
  .prod-img
  .prod-img-question {
  width: 11.15 * 4.2px;
  height: 11.15 * 4.2px;
  position: absolute;
  left: 5.24 * 4.2px;
  bottom: 3.33 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .left-prod .prod-img .wear,
.luck-page .lucky-content-wrap .content-top .right-box .prod-img .wear {
  width: 13.73 * 4.2px;
  height: 5.2 * 4.2px;
  // background: url("../../assets/images/left_prod_box_mask.png") no-repeat 0 0;
  // background-size: 19.73 * 4.2px 5.2 * 4.2px;
  position: absolute;
  top: 0.48 * 4.2px;
  left: 5.07 * 4.2px;
  text-indent: 1.07 * 4.2px;
  font-size: 2.33 * 4.2px;
  color: #ffffff;
}

.luck-page .lucky-content-wrap .content-top .right-box {
  width: 24.05 * 4.2px;
  height: 22.62 * 4.2px;
  background: url("../../assets/image3/blindBox/sjwbBack.png") no-repeat 0 0;
  background-size: 24.05 * 4.2px 22.62 * 4.2px;
  position: absolute;
  z-index: 3;
  top: 9.07 * 4.2px;
  right: 3 * 4.2px;
}

.luck-page .lucky-content-wrap .content-top .right-box .text {
  width: 20.8 * 4.2px;
  height: 5.2 * 4.2px;
  line-height: 5.47 * 4.2px;
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: right;
  padding-right: 1.07 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap {
  width: 100%;
  height: 17.07 * 4.2px;
  // background: url("../../assets/images/progress_box_bg.png") no-repeat 0 0;
  // background-size: 90.4 * 4.2px 17.07 * 4.2px;
  position: absolute;
  z-index: 3;
  left: 0;
  top: 35.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .progress-btn {
  width: 13.67 * 4.2px;
  height: 14.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .add-btn {
  // margin: 5.04px 19.026px 0 -5.64px;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .reduce-btn {
  float: right;
  margin: 0 11.8px 0 5.586px;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .reduce-btn-img {
  width: 13.53 * 4.2px;
  height: 11.33 * 4.2px;
  margin-left: 12.86 * 4.2px;
  z-index: 2;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .add-btn-img {
  width: 13.53 * 4.2px;
  height: 11.33 * 4.2px;
  margin-right: 11.91 * 4.2px;
  z-index: 2;
}

.luck-page .lucky-content-wrap .content-top .progress-box-wrap .progress {
  width: 250px;
  height: 7 * 4.2px;
  margin: -1px 1.2rem 0 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  background: url("../../assets/image3/blindBox/progress-strip.png") no-repeat 0
    0;
  background-size: 100% 100%;
}

.luck-page .lucky-content-wrap .content-top .tab-box-wrap {
  width: 100 * 4.2px;
  height: 6.8 * 4.2px;
  padding: 0 4.07 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  z-index: 3;
  left: 0;
  bottom: -1.33 * 4.2px;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.luck-page .lucky-content-wrap .content-top .tab-box-wrap .btn-item {
  width: 18.26 * 4.2px;
  height: 7.28 * 4.2px;
  line-height: 7.28 * 4.2px;
  background: url("../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  color: #fff;
  font-size: 3 * 4.2px;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
}

.luck-page .lucky-content-wrap .content-top .tab-box-wrap .btn-item.sel {
  background: url("../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  color: #ffffff;
}

.luck-page .lucky-content-wrap .content-top .tab-box-wrap .award-show {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 2.67 * 4.2px;
  color: #c7d4ff;
}

.luck-page
  .lucky-content-wrap
  .content-top
  .tab-box-wrap
  .award-show
  .color-blue {
  width: 2.67 * 4.2px;
  height: 2.67 * 4.2px;
  background: url("../../assets/images/k25.png") no-repeat 0 0;
  background-size: 2.67 * 4.2px 2.67 * 4.2px;
  margin-right: 1.07 * 4.2px;
}

.luck-page .lucky-content-wrap .prod-select-box {
  width: 396px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-top: 5 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  z-index: 3;
 
  margin: 1rem 1rem;
  // height: calc(100vh - 400px);
}
.luck-page .lucky-content-wrap .prod-select-box.show{
  background: url("~@/assets/knapsack/5.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.luck-page .lucky-content-wrap .prod-select-box .prod-select-outer {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 0 2.13 * 4.2px 0 2.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item {
  width: 6.625rem;
  height: 8rem;
  background: url("~@/assets/knapsack/7.png") no-repeat 0 0;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  font-size: 2.31 * 4.2px;
  border-radius: 2px 2px 2px 2px;
  border: 0px solid #b378e0;
  padding: 1.9 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  color: #e5c7ff;
  position: relative;
  margin-bottom: 8.4px;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .shpo-img {
  width: 80%;
  height: auto;
  margin: 4.76 * 4.2px auto;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item.sel {
  background: url("~@/assets/knapsack/7-1.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item.sel
  .name {
  color: #ffc897;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .award {
  width: 6rem;
  height: 2rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 10px;
  color: #e5c7ff;

  position: absolute;
  left: 1.19 * 4.2px;
  bottom: 2.38 * 4.2px;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .select {
  width: 7.14 * 4.2px;
  height: 7.14 * 4.2px;
  position: absolute;
  top: 0;
  right: 0;

  @media only screen and (max-width: 430px) {
    width: 7.14vw;
    height: 7.14vw;
  }
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .name {
  width: 4rem;
  // height: 2rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto;
  // text-align: center;
  color: #95a2ff;
  font-size: 10px;
  position: absolute;
  left: 0;
  bottom: 0.6rem;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 2.86 * 4.2px;

  position: absolute;
  top: 1.19 * 4.2px;
  left: 1.19 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.86vw;
    top: 1.19vw;
    left: 1.19vw;
  }
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .price
  img {
  width: 3 * 4.2px;
  height: 3 * 4.2px;
  margin-right: 0.53 * 4.2px;
}

.luck-page
  .lucky-content-wrap
  .prod-select-box
  .prod-select-outer
  .scroll-select-wrap
  .scroll-select-inner
  .prod-item
  .price
  text {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#edb375),
    to(#ffffff)
  );
  background-image: -webkit-linear-gradient(top, #edb375, #ffffff);
  background-image: -o-linear-gradient(top, #edb375, #ffffff);
  background-image: linear-gradient(to bottom, #edb375, #ffffff);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  font-family: "Alimama ShuHeiTi", serif;
}

.luck-page .lucky-content-wrap .history-box {
  width: 100 * 4.2px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

.luck-page .lucky-content-wrap .item-box {
  height: 26.67 * 4.2px;
  width: 100 * 4.2px;
  border: 1px solid blue;
}

.luck-page .btm-opt-box {
  width: 100 * 4.2px;
  height: 25 * 4.2px;
  position: relative;
  left: 0;
  bottom: 0;
  right: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 10;
  background: rgba(10, 0, 76, 0.36);
}

.luck-page .btm-opt-box .top {
  width: 100 * 4.2px;
  height: 5.47 * 4.2px;
  // background: url("../../assets/images/shadow_line.png") no-repeat 0 0;
  // background-size: 100 * 4.2px 5.47 * 4.2px;
  margin-bottom: -1.33 * 4.2px;
}

.luck-page .btm-opt-box .opt-box {
  width: 100 * 4.2px;
  height: 34.93 * 4.2px;
  // background: url("../../assets/images/btm_bg_1.png") no-repeat 0 0;
  // background-size: 100 * 4.2px 34.93 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.luck-page .btm-opt-box .opt-box .btn {
  width: 9rem;
    height: 3.2rem;
  background: url("../../assets/image3/home/unpackingBack.png") no-repeat 0 0;
  background-size: contain;
  position: absolute;
  top: 1rem;
  right: 0rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 10;
}

.luck-page .btm-opt-box .opt-box .btn .price {
  max-width: 100%;
  height: auto;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  letter-spacing: 0.1 * 4.2px;
  background: linear-gradient(90deg, #FFFFFF 0%, #FFAF24 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent
}

.luck-page .btm-opt-box .opt-box .btn .text-img {
  width: 14.27 * 4.2px;
  height: 8.13 * 4.2px;
  margin: -1.33 * 4.2px 0 0 0.67 * 4.2px;
}

.luck-page .btm-opt-box .opt-box .disabled-btn {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  -webkit-filter: gray;
  filter: gray;
}

.luck-page .btm-opt-box .opt-box .btm-layer-1 {
  width: 100 * 4.2px;
  height: 29.6 * 4.2px;
  background-image: url("../../assets/images/btm_bg_2.png");
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  bottom: 5.07 * 4.2px;
  right: 0;
}

.luck-page .btm-opt-box .opt-box .btm-layer-1 .box {
  width: 100%;
  height: 100%;
}

.luck-page .btm-opt-box .opt-box .btm-layer-2 {
  width: 100 * 4.2px;
  height: 14.67 * 4.2px;
  background: url("../../assets/images/btm_bg_3.png") no-repeat 0 0;
  background-size: 100 * 4.2px 14.67 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}

.luck-page .btm-opt-box .open-record {
  position: absolute;
  top: 6 * 4.2px;
  left: -0.83 * 4.2px;
  width: 14 * 4.2px;
  height: 8.4 * 4.2px;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/box_bg_1.png");
}

.luck-page .btm-opt-box .open-record .icon {
  width: 4rem;
  height: 3rem;
  // margin: 1.73 * 4.2px 0 0 6.27 * 4.2px;
  background-size: contain;
  background-image: url("../../assets/image3/home/information.png");
  background-repeat: no-repeat;
  margin-left: 2rem;
}

.luck-page .btm-opt-box .open-setting {
  position: absolute;
  top: 15.33 * 4.2px;
  right: 0;
  width: 14 * 4.2px;
  height: 8.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_2.png");
}

.luck-page .btm-opt-box .open-setting .icon {
  float: right;
  width: 4.53 * 4.2px;
  height: 4.53 * 4.2px;
  margin: 1.73 * 4.2px 6.13 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/images/system-icon.png");
}

.lucky-clock {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  // background-image: url("../../assets/images/lucky_bk_c1.png");
  // background-image: url("../../assets/image3/blindBox/progress-ring.png");
}

.lucky-clock .top-progress-back {
  width: 80%;
  height: 80%;
  position: absolute;
  z-index: 3;
  top: 4.6 * 4.2px;
  left: 4.5 * 4.2px;

  @media only screen and (max-width: 430px) {
    top: 4.6vw;
    left: 4.5vw;
  }
}

.lucky-clock .show-prize {
  position: absolute;
  top: 2.67 * 4.2px;
  left: 2.67 * 4.2px;
  width: 40 * 4.2px;
  height: 40 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/show_prize.png");
  -webkit-animation: showPrizeKf1 0.6s linear 0s 2;
  animation: showPrizeKf1 0.6s linear 0s 2;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@-webkit-keyframes showPrizeKf1 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes showPrizeKf1 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.lucky-clock .show-light-bg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 45.33 * 4.2px;
  height: 45.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/clock_bg1.png");
  -webkit-animation: showPrizeKf1 0.6s linear 0s 2;
  animation: showPrizeKf1 0.6s linear 0s 2;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@keyframes showPrizeKf1 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.lucky-clock .svg-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // scale: 0.6;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  z-index: 1;
}

.lucky-clock .svg-progress .svg-circle01 {
  -webkit-animation: svgC1Kf1 0.5s linear 0s 6;
  animation: svgC1Kf1 0.5s linear 0s 6;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@-webkit-keyframes svgC1Kf1 {
  0% {
    opacity: 0;
  }

  60% {
    opacity: 0;
  }

  61% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

@keyframes svgC1Kf1 {
  0% {
    opacity: 0;
  }

  60% {
    opacity: 0;
  }

  61% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

.lucky-clock .svg-progress .svg-circle02 {
  -webkit-animation: svgC1Kf2 0.5s linear 0s 6;
  animation: svgC1Kf2 0.5s linear 0s 6;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@-webkit-keyframes svgC1Kf2 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes svgC1Kf2 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.lucky-clock .svg-progress .svg-circle11 {
  -webkit-animation: svgC2Kf1 0.6s linear 0s 2;
  animation: svgC2Kf1 0.6s linear 0s 2;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@-webkit-keyframes svgC2Kf1 {
  0% {
    opacity: 0;
  }

  60% {
    opacity: 0;
  }

  61% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

@keyframes svgC2Kf1 {
  0% {
    opacity: 0;
  }

  60% {
    opacity: 0;
  }

  61% {
    opacity: 1;
  }

  100% {
    opacity: 1;
  }
}

.lucky-clock .svg-progress .svg-circle12 {
  -webkit-animation: svgC2Kf2 0.6s linear 0s 2;
  animation: svgC2Kf2 0.6s linear 0s 2;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}

@-webkit-keyframes svgC2Kf2 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes svgC2Kf2 {
  0% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  61% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.lucky-clock .svg-progress .svg-circle1 {
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
}

.lucky-clock .svg-progress .dashAnima {
  -webkit-transition: stroke-dasharray 0.9s;
  -o-transition: stroke-dasharray 0.9s;
  transition: stroke-dasharray 0.9s;
}

.lucky-clock .pointer-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 45.33 * 4.2px;
  height: 45.33 * 4.2px;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/lucky_bk_p1.png");
  --luckyClockStart: 0deg;
  --luckyClockEnd: 5800deg;
  --luckyClockTime: 5s;
  transition-timing-function: ease-in-out;
}

.lucky-clock .pointer-box .pointer-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.lucky-clock .pointer-box .pointer-inner .pointer-light {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 45.33 * 4.2px;
  height: 45.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/lucky_bk_p3.png");
}

.lucky-clock .pointer-box .pointer-inner .pointer-light.p-anim {
  -webkit-animation: pointerLightKf01 0.5s linear 1;
  animation: pointerLightKf01 0.5s linear 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes pointerLightKf01 {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes pointerLightKf01 {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.lucky-clock .pointer-box.rotate-loop {
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation: clockRotateAnimKF0 1s linear 0s infinite;
  animation: clockRotateAnimKF0 1s linear 0s infinite;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes clockRotateAnimKF0 {
  0% {
    -webkit-transform: rotate(var(--luckyClockStart));
    transform: rotate(var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(
      -webkit-calc(var(--luckyClockStart) + 360deg * 5)
    );
    transform: rotate(calc(var(--luckyClockStart) + 360deg * 5));
  }
}

@keyframes clockRotateAnimKF0 {
  0% {
    -webkit-transform: rotate(var(--luckyClockStart));
    transform: rotate(var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(
      -webkit-calc(var(--luckyClockStart) + 360deg * 5)
    );
    transform: rotate(calc(var(--luckyClockStart) + 360deg * 5));
  }
}

.lucky-clock .pointer-box.rotate1 {
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation: clockRotateAnimKF1 var(--luckyClockTime)
    cubic-bezier(0.1, 0.79, 0.5, 0.1) 0s 1;
  animation: clockRotateAnimKF1 var(--luckyClockTime)
    cubic-bezier(0.1, 0.79, 0.5, 0.1) 0s 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes clockRotateAnimKF1 {
  0% {
    -webkit-transform: rotate(var(--luckyClockStart));
    transform: rotate(var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(var(--luckyClockEnd));
    transform: rotate(var(--luckyClockEnd));
    transition-timing-function: ease-out;
  }
}

@keyframes clockRotateAnimKF1 {
  0% {
    -webkit-transform: rotate(var(--luckyClockStart));
    transform: rotate(var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(var(--luckyClockEnd));
    transform: rotate(var(--luckyClockEnd));
    transition-timing-function: ease-out;
  }
}

.lucky-clock .pointer-box.rotate2 {
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation: clockRotateAnimKF2 var(--luckyClockTime)
    cubic-bezier(0.1, 0.79, 0.5, 0.1) 0s 1;
  animation: clockRotateAnimKF2 var(--luckyClockTime)
    cubic-bezier(0.1, 0.79, 0.5, 0.1) 0s 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes clockRotateAnimKF2 {
  0% {
    -webkit-transform: rotate(-var(--luckyClockStart));
    transform: rotate(-var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(var(--luckyClockEnd));
    transform: rotate(var(--luckyClockEnd));
    transition-timing-function: ease-out;
  }
}

@keyframes clockRotateAnimKF2 {
  0% {
    -webkit-transform: rotate(-var(--luckyClockStart));
    transform: rotate(-var(--luckyClockStart));
  }

  100% {
    -webkit-transform: rotate(var(--luckyClockEnd));
    transform: rotate(var(--luckyClockEnd));
    transition-timing-function: ease-out;
  }
}

.lucky-clock .percentage-box {
  position: absolute;
  top: 16.8 * 4.2px;
  left: 16.8 * 4.2px;
  width: 11.87 * 4.2px;
  height: 11.87 * 4.2px;
  text-align: center;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/lucky_bk_p2.png");
}

.lucky-clock .percentage-box .progress {
  height: 6.13 * 4.2px;
  line-height: 6.13 * 4.2px;
  font-size: 5.6 * 4.2px;
  font-weight: 700;
  margin-top: 2.67 * 4.2px;
  font-family: Russo One, Russo One;
}

.lucky-clock .percentage-box .unit {
  height: 2.8 * 4.2px;
  line-height: 2.8 * 4.2px;
  font-size: 2.27 * 4.2px;
  font-weight: 700;
  margin-top: -0.8 * 4.2px;
}

.lucky-clock .prize-layer {
  width: 100 * 4.2px;
  height: 100vh;
}

.lucky-clock .trace-light {
  position: absolute;
  top: 0;
  left: 0;
  width: 45.33 * 4.2px;
  height: 45.33 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/trace_light.png");
}

.history-order-record {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
}

.history-order-record .history-order-scroll-box {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.history-order-record .history-order-scroll-box .scroll-box-inner {
  width: 100 * 4.2px;
  height: auto;
  overflow: hidden;
  padding: 0 2.13 * 4.2px 0 2.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.order-item {
  width: 93.6 * 4.2px;
  height: 13.81 * 4.2px;
  background: linear-gradient( 320deg, #05164E 0%, #0B2DB4 100%);
border-radius: 8px 8px 8px 8px;
border: 1px solid;
border-image: linear-gradient(96deg, rgba(179, 223, 255, 1), rgba(48, 168, 255, 0), rgba(172, 220, 255, 1)) 1 1;
  margin: 0 auto 2.13 * 4.2px auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.33 * 4.2px;
}

.order-item.sel {
  background: linear-gradient( 320deg, #460067 0%, #8A0BB4 100%);
border-radius: 8px 8px 8px 8px;
border: 1px solid;
border-image: linear-gradient(96deg, rgba(179, 223, 255, 1), rgba(48, 168, 255, 0), rgba(172, 220, 255, 1)) 1 1;
}

.order-item.sel .user-info .nick {
  color: #fff;
}

.order-item.sel .user-info .time {
  color: #fff;
}

.order-item.sel .award {
  color: #fff;
}

.order-item.sel .price .price-1 {
  color: #fff;
}

.order-item.sel .price .price-2 {
  color: #fff;
}

.order-item .user-info {
  width: 36 * 4.2px;
  height: 13.81 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-right: 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.order-item .user-info .avatar {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  margin: 0 1.87 * 4.2px;
  position: relative;
}

.order-item .user-info .avatar img {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
  overflow: hidden;
}

.order-item .user-info .avatar .mask {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  // background: url(data:image/png;base64,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) no-repeat 0 0;
  // background-size: 6.4 * 4.2px 6.4 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
}

.order-item .user-info .nick {
  width: 27.73 * 4.2px;
  color: #fff;
  // margin-top: 1.33 * 4.2px;
  text-align: left;
  font-size: 3.33 * 4.2px;
}

.order-item .user-info .time {
  color: #fff;
  font-size: 2.67 * 4.2px;
  margin-top: 1.19 * 4.2px;
}

.order-item .award {
  width: 17.33 * 4.2px;
  height: 13.81 * 4.2px;
  line-height: 13.81 * 4.2px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 4 * 4.2px;
  color: #fff;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
}

.order-item .prod-img {
  width: 13.33 * 4.2px;
  height: 13.81 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.order-item .prod-img img {
  width: 9.6 * 4.2px;
  height: 7.2 * 4.2px;
}

.order-item .price {
  width: 24 * 4.2px;
  height: 13.81 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-right: 2 * 4.2px;
}

.order-item .price .price-1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-size: 3.33 * 4.2px;
  font-weight: 400;
  color: #fff;
}

.order-item .price .price-2 {
  font-size: 2.67 * 4.2px;
  color: #fff;
}

.svga-div {
  position: relative;
  width: 100%;
  height: 100%;
}

.appview {
  height: calc(100vh - 164px);
}

.top-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

::v-deep .el-progress-circle {
  width: 30 * 4.2px !important;
  height: 30 * 4.2px !important;

  @media only screen and (max-width: 430px) {
    width: 30vw !important;
    height: 30vw !important;
  }
}

.bottom-slider {
  width: 100%;
}

// ::v-deep .el-slider__button-wrapper {
//   z-index: 2;
// }
::v-deep .el-slider__runway {
  height: 13px;
  background-color: rgba(71, 79, 92, 0.1);
  // background: #474f5c 0;
}

::v-deep .el-slider__bar {
  height:0.8rem;
  background: linear-gradient(to right, #00a0e9, #d000fa);
}

::v-deep .el-slider__button-wrapper {
  top: -20px;
}

::v-deep .el-slider__button {
  // background: #25f484;
  // 拖动的滑块的样式
  width: 1.43 * 4.2px;
  height: 12.05 * 4.2px;
  border: none;
  background: url("../../assets/image3/blindBox/progress-switch.png") no-repeat
    center center;
  background-size: contain;
  border-radius: inherit;
  font-size: 0px;

  @media only screen and (max-width: 430px) {
    width: 1.43vw;
    height: 12.05vw;
  }
}

@media only screen and (max-width: 430px) {
  .appview {
    height: calc(100vh - 33vw) !important;
  }

  .lucky {
    --head-height: 14vw;
  }

  .luck-page .page-content-new {
    background-size: 100vw 88.4vw;
  }

  .luck-page .lucky-content-wrap {
    width: 100vw;
    // padding-top: var(--head-height);
  }

  .luck-page .lucky-content-wrap .lucky-clock-box {
    top: -2.67vw;
    left: 27.33vw;
    width: 45.33vw;
    height: 45.33vw;
  }

  .luck-page .lucky-content-wrap .lucky-clock-box .pointer-bg {
    left: -27.33vw;
    top: -1px;
    width: 100vw;
    height: 65.33vw;
  }

  .luck-page .lucky-content-wrap .lucky-clock-box .box-bg {
    left: -27.33vw;
    top: -6vw;
    width: 100vw;
    height: 66.13vw;
  }

  .luck-page .lucky-content-wrap .content-top {
    width: 100vw;
    height: 60.67vw;
    margin-top: 1.33vw;
  }

  .luck-page .lucky-content-wrap .content-top .rule-icon {
    position: absolute;
    top: 3.07vw;
    right: 2.67vw;
    width: 4.53vw;
    height: 4.53vw;
  }

  .luck-page .lucky-content-wrap .content-top .left-prod {
    width: 25.47vw;
    height: 23.33vw;

    left: 2.93vw;
    top: 9.27vw;
  }

  .luck-page .lucky-content-wrap .content-top .left-prod .name {
    width: 14.47vw;
    height: 6.53vw;
    line-height: 6.53vw;
    font-size: 2.7vw;

    text-indent: 1.73vw;

    z-index: 2;
    top: -0.95vw;
    left: 4.29vw;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner
    .prod-item
    .shpo-img {
    width: 80%;
    margin: 4.76vw auto;
  }

  .luck-page .lucky-content-wrap .content-top .left-prod .prod-img {
    width: 24.05vw;
    height: 22.62vw;

    background-size: 24.05vw 22.62vw;
  }

  .luck-page .lucky-content-wrap .content-top .left-prod .prod-img img,
  .luck-page .lucky-content-wrap .content-top .right-box .prod-img img {
    width: 20.13vw;
    height: 15.07vw;
    margin: 0.93vw 1.33vw 0.8vw 1.33vw;
    left: 0.95vw;
    bottom: 0.48vw;
  }

  .luck-page
    .lucky-content-wrap
    .content-top
    .right-box
    .prod-img
    .prod-img-question {
    width: 11.15vw;
    height: 11.15vw;
    position: absolute;
    left: 5.24vw;
    bottom: 3.33vw;
  }

  .luck-page .lucky-content-wrap .content-top .left-prod .prod-img .wear,
  .luck-page .lucky-content-wrap .content-top .right-box .prod-img .wear {
    width: 13.73vw;
    height: 5.2vw;

    background-size: 19.73vw 5.2vw;

    top: 0.48vw;
    left: 5.07vw;

    text-indent: 1.07vw;
    font-size: 2.33vw;
  }

  .luck-page .lucky-content-wrap .content-top .right-box {
    width: 24.05vw;
    height: 22.62vw;

    background-size: 24.05vw 22.62vw;

    top: 9.07vw;
    right: 3vw;
  }

  .luck-page .lucky-content-wrap .content-top .right-box .text {
    width: 20.8vw;
    height: 5.2vw;
    line-height: 5.47vw;
    padding-right: 1.07vw;

    font-size: 3.33vw;
  }

  .luck-page .lucky-content-wrap .content-top .progress-box-wrap {
    width: 100vw;
    height: 17.07vw;

    background-size: 90.4vw 17.07vw;

    left: 0;
    top: 35.87vw;
  }

  .luck-page .lucky-content-wrap .content-top .progress-box-wrap .progress-btn {
    width: 13.67vw;
    height: 14.2vw;
  }

  .luck-page
    .lucky-content-wrap
    .content-top
    .progress-box-wrap
    .reduce-btn-img {
    width: 13.53vw;
    height: 11.33vw;
    margin-left: 12.86vw;
    z-index: 2;
  }

  .luck-page .lucky-content-wrap .content-top .progress-box-wrap .add-btn-img {
    width: 13.53vw;
    height: 11.33vw;
    margin-right: 11.91vw;
    z-index: 2;
  }

  .luck-page .lucky-content-wrap .content-top .progress-box-wrap .progress {
    width: 100vw;
    height: 7vw;
  }

  .luck-page .lucky-content-wrap .content-top .tab-box-wrap {
    width: 100vw;
    height: 6.8vw;
    padding: 0 4.07vw;

    bottom: -1.33vw;
  }

  .luck-page .lucky-content-wrap .content-top .tab-box-wrap .btn-item {
    width: 18.26vw;
    height: 7.28vw;
    line-height: 7.28vw;
    background-size: 18.26vw 7.28vw;
    font-size: 3vw;
  }

  .luck-page .lucky-content-wrap .content-top .tab-box-wrap .btn-item.sel {
    background-size: 18.26vw 7.28vw;
  }

  .luck-page .lucky-content-wrap .content-top .tab-box-wrap .award-show {
    font-size: 2.67vw;
  }

  .luck-page
    .lucky-content-wrap
    .content-top
    .tab-box-wrap
    .award-show
    .color-blue {
    width: 2.67vw;
    height: 2.67vw;
    background-size: 2.67vw 2.67vw;
    margin-right: 1.07vw;
  }

  .luck-page .lucky-content-wrap .prod-select-box {
    width: 92%;

    padding-top: 5vw;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner {
    width: 100%;

    padding: 0 2.13vw 0 2.27vw;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner
    .prod-item {
    // width: 21.73*1.3vw;
    // height: 22.6*1.3vw;

    // // background-size: 21.73*1.3vw 15.6*1.3vw;

    // margin: 0 2.2vw 2.93*1.3vw 0.93*1.3vw;

    // font-size: 2vw;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner
    .prod-item.sel {
    // background-size: 28.249vw 20.28vw;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner
    .prod-item
    .award {
    left: 1.19vw;
    bottom: 2.38vw;
  }

  .luck-page
    .lucky-content-wrap
    .prod-select-box
    .prod-select-outer
    .scroll-select-wrap
    .scroll-select-inner
    .prod-item
    .price
    img {
    width: 3vw;
    height: 3vw;
    margin-right: 0.53vw;
  }

  .luck-page .lucky-content-wrap .history-box {
    width: 100vw;
  }

  .luck-page .lucky-content-wrap .item-box {
    height: 26.67vw;
    width: 100vw;
  }

  .luck-page .btm-opt-box {
    width: 100vw;
    height: 25vw;
    position: fixed;
    bottom: 0;
  }

  .luck-page .btm-opt-box .top {
    width: 100vw;
    height: 5.47vw;

    background-size: 100vw 5.47vw;
    margin-bottom: -1.33vw;
  }

  .luck-page .btm-opt-box .opt-box {
    width: 100vw;
    height: 26.39vw;
    // background: rgba(10, 0, 76, 0.36);
    // border-radius: 8px 8px 8px 8px;
    // background: #201B2A url("../../assets/images/btm_bg_1.png") no-repeat 0 0;
    // background-size: 100vw 34.93vw;
  }

  .luck-page .btm-opt-box .opt-box .btn .text-img {
    width: 14.27vw;
    height: 8.13vw;
    margin: -1.33vw 0 0 0.67vw;
  }

  .luck-page .btm-opt-box .opt-box .btm-layer-1 {
    width: 100vw;
    height: 29.6vw;

    bottom: 5.07vw;
  }

  .luck-page .btm-opt-box .opt-box .btm-layer-2 {
    width: 100vw;
    height: 14.67vw;

    background-size: 100vw 14.67vw;
  }

  .luck-page .btm-opt-box .open-record {
    top: 6vw;
    left: -0.83vw;

    width: 14vw;
    height: 8.4vw;
  }

  .luck-page .btm-opt-box .open-setting {
    top: 15.33vw;

    width: 14vw;
    height: 8.4vw;
  }

  .luck-page .btm-opt-box .open-setting .icon {
    width: 4.53vw;
    height: 4.53vw;
    margin: 1.73vw 6.13vw 0 0;
  }

  .lucky-clock .show-prize {
    position: absolute;
    top: 2.67vw;
    left: 2.67vw;
    width: 40vw;
    height: 40vw;
  }

  .lucky-clock .show-light-bg {
    width: 45.33vw;
    height: 45.33vw;
  }

  .lucky-clock .pointer-box {
    width: 45.33vw;
    height: 45.33vw;
  }

  .lucky-clock .pointer-box .pointer-inner .pointer-light {
    width: 45.33vw;
    height: 45.33vw;
  }

  .lucky-clock .percentage-box {
    top: 16.8vw;
    left: 16.8vw;
    width: 11.87vw;
    height: 11.87vw;
  }

  .lucky-clock .percentage-box .progress {
    height: 6.13vw;
    line-height: 6.13vw;
    font-size: 5.6vw;

    margin-top: 2.67vw;
  }

  .lucky-clock .percentage-box .unit {
    height: 2.8vw;
    line-height: 2.8vw;
    font-size: 2.27vw;
    margin-top: -0.8vw;
  }

  .lucky-clock .prize-layer {
    width: 100vw;
    height: 100vh;
  }

  .lucky-clock .trace-light {
    width: 45.33vw;
    height: 45.33vw;
  }
  .order-item .price .price-2 {
    font-size: 2.67vw;
  }
}
</style>
